import { useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { SOLICITUD_ALTERNATIVAS_API } from '../../../shared/services/solicitudAlternativas';
import ActionButton from '../ActionButton';
import { getAtClienteUserId } from '../../actions';

const AsignarAtClienteModal = ({ currentItem, onClose, onSolicitudUpdated }) => {
    const atencionClientes = useSelector(
        (state) => state.atencion_cliente || [],
    );
    const assignedAtClienteUserId = getAtClienteUserId(
        currentItem?.crafted_by,
    );
    const currentUsername =
        currentItem?.crafted_by?.username?.toUpperCase() || null;
    const [selectedUserId, setSelectedUserId] = useState(
        assignedAtClienteUserId ? String(assignedAtClienteUserId) : '',
    );
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async () => {
        if (!selectedUserId) {
            toast.error('Selecciona un usuario de atención al cliente.');
            return;
        }

        if (
            assignedAtClienteUserId &&
            Number(selectedUserId) === Number(assignedAtClienteUserId)
        ) {
            toast.info('Selecciona un responsable distinto al actual.');
            return;
        }

        setSubmitting(true);
        try {
            const res = await SOLICITUD_ALTERNATIVAS_API.asignar({
                solicitud_id: currentItem.id,
                crafted_by: parseInt(selectedUserId),
            });
            if (res?.success) {
                toast.success(
                    assignedAtClienteUserId
                        ? 'Responsable actualizado correctamente.'
                        : 'Asignado correctamente.',
                );
                onSolicitudUpdated?.(res.data);
                onClose();
            }
        } catch (e) {
            toast.error(
                e?.response?.data?.message ||
                    e?.message ||
                    (assignedAtClienteUserId
                        ? 'Error al cambiar el responsable.'
                        : 'Error al asignar.'),
            );
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div>
            {assignedAtClienteUserId && currentUsername ? (
                <div
                    className="mb-3"
                    style={{ fontSize: '13px', color: '#5c5c5c' }}
                >
                    Responsable actual:{' '}
                    <span className="fw-semibold text-capitalize">
                        {currentUsername}
                    </span>
                </div>
            ) : null}
            <div className="form-group">
                <select
                    className="form-control"
                    style={{
                        appearance: 'auto',
                        WebkitAppearance: 'auto',
                        MozAppearance: 'auto',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                    }}
                    value={selectedUserId}
                    onChange={(e) => setSelectedUserId(e.target.value)}
                >
                    <option value="">Seleccionar usuario...</option>
                    {atencionClientes?.map((user) => (
                        <option key={user.id} value={user.id}>
                            {user.username?.toUpperCase()}
                        </option>
                    ))}
                </select>
            </div>

            <div className="d-flex justify-content-end mt-4">
                <ActionButton
                    disabled={submitting || !selectedUserId}
                    loading={submitting}
                    label={assignedAtClienteUserId ? 'Cambiar' : 'Asignar'}
                    onClick={handleSubmit}
                />
            </div>
        </div>
    );
};

export default AsignarAtClienteModal;
